<template>
  <v-dialog v-model="dialog" max-width="500" :persistent="loading">
    <v-card>
      <v-card-title class="text-h5">
        <v-icon left color="primary">mdi-store-plus</v-icon>
        Adicionar Loja
      </v-card-title>
      <v-card-text>
        <h6 class="mb-2">Dados do proprietário</h6>
        <v-form v-model="valid" @submit.prevent="save">
          <v-text-field
            v-model="user.name"
            label="Nome"
            required
            outlined
            dense
            prepend-inner-icon="mdi-account"
            :rules="[(v) => !!v || 'Nome é obrigatório']"
          />
          <v-text-field
            v-model="user.email"
            label="Email"
            required
            outlined
            dense
            prepend-inner-icon="mdi-email"
            :rules="[(v) => !!v || 'Email é obrigatório']"
          />
          <v-text-field-simplemask
            v-model="user.phone"
            label="Whatsapp"
            :properties="{
              prefix: '',
              suffix: '',
              rules: [
                (v) => !!v || 'Whatsapp é obrigatório',
                (v) => (v && v.length === 15) || 'Whatsapp inválido',
              ],
              disabled: loading,
              outlined: true,
              dense: true,
              placeholder: '',
              prependInnerIcon: 'mdi-whatsapp',
            }"
            v-bind:options="{
              inputMask: '(##) #####-####',
              outputMask: '###########',
              empty: null,
              applyAfter: false,
              alphanumeric: true,
              lowerCase: false,
            }"
          />
        </v-form>
        <v-alert v-if="error" type="error" class="mb-0">
          {{ error }}
        </v-alert>
      </v-card-text>
      <v-card-actions>
        <v-btn text @click="dialog = false" :disabled="loading">
          <v-icon left>mdi-close</v-icon>
          Cancelar
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          @click="save"
          :loading="loading"
          :disabled="!valid"
        >
          <v-icon left>mdi-plus</v-icon>
          Adicionar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import adminService from "@/services/admin";

const defaultUser = () => ({
  name: "",
  email: "",
  phone: "",
});
export default {
  data() {
    return {
      dialog: false,
      error: null,
      loading: false,
      valid: false,
      user: {
        name: "",
        email: "",
        phone: "",
      },
    };
  },
  methods: {
    open() {
      this.dialog = true;
      this.user = defaultUser();
    },
    async save() {
      try {
        this.loading = true;
        this.error = null;
        await adminService.stores.create({ user: this.user });
        this.$emit("refresh");
        this.dialog = false;
      } catch (error) {
        this.error = error.message || "Erro ao adicionar loja";
      } finally {
        this.loading = false;
      }
    },
  },
  mounted() {
    this.$root.$on("open-add-store-modal", this.open);
  },
  beforeDestroy() {
    this.$root.$off("open-add-store-modal", this.open);
  },
};
</script>

<style scoped>
.v-card-title {
  background: #fafafa;
  color: #424242;
  border-bottom: 1px solid #e0e0e0;
}
</style>
